import helpers from '../helpers';
import verifiers from '../verifiers';

class LCHColor {
  constructor(lightness, chroma, hue, alpha = 1) {
    this.lightness = lightness;
    this.chroma = chroma;
    this.hue = hue;
    this.alpha = alpha;
    helpers.checkRange(lightness, Number.MAX_VALUE, 'lightness');
    helpers.checkRange(chroma, Number.MAX_VALUE, 'chroma');
    helpers.checkRange(hue, 360, 'hue');
    helpers.checkRange(alpha, 1, 'alpha');
  }

  equals({ lightness, chroma, hue, alpha }) {
    const { isShadesEqual } = verifiers;
    return (
      isShadesEqual(this.lightness, lightness) &&
      isShadesEqual(this.chroma, chroma) &&
      isShadesEqual(this.hue, hue) &&
      isShadesEqual(this.alpha, alpha)
    );
  }
}

export default LCHColor;
